import React from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

const alignClass = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

const flexAlign = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

/**
 * Clickable column header for client-side table sorting.
 */
export function SortableTableHead({
  label,
  field,
  activeField,
  sortDir,
  onSort,
  align = 'left',
  className = '',
}) {
  const active = activeField === field;
  const Icon = active ? (sortDir === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown;

  return (
    <th
      scope="col"
      className={`px-4 py-3 text-xs font-bold text-gray-500 uppercase cursor-pointer select-none hover:bg-gray-100 transition-colors ${alignClass[align] || alignClass.left} ${className}`}
      onClick={() => onSort(field)}
    >
      <div className={`inline-flex items-center gap-1 max-w-full ${flexAlign[align] || flexAlign.left}`}>
        <span>{label}</span>
        <Icon className={`w-3.5 h-3.5 shrink-0 ${active ? 'text-red-600' : 'text-gray-400'}`} aria-hidden />
      </div>
    </th>
  );
}
